import {Grid, useTheme} from "@mui/material";
import DealMenu from "../components/DealMenu";
import {Item} from "../../../domains/common/components/Item";
import RealtyFormContainer from "../components/Realty";
import {RolesEnums} from "../../../enums";
import {FilesListContainer} from "../components/FilesContainer";
import {XmlList} from "../components/XmlList";
import React, {useState} from "react";
import {FormInput, FormInputDate, Textarea} from "../../../domains/common/components/FormInput";
import {Responsible} from "../components/Responsible";
import {dealData} from "../deal";
import {waitInputComplete} from "../../../fn";
import {ParticipantsComponent} from "../components/Participants";
import { ChildStatmentContainer } from "../components/ChildStatement";
import DealCommentContainer from "../components/Comment";
/**
 * Тип сделки Регистрация соглашения об уступке
 * @returns {Element}
 * @constructor
 */
export function DealMakingChangesContainer() {
  const theme = useTheme();
  return (
    <Grid container spacing={1} sx={{mt: 0.2}}>
      <Grid item xs={12}>
        <DealMenu dealId={dealData.dealId}></DealMenu>
      </Grid>
      <Grid item xs={12}>
        <Item sx={{backgroundColor: theme.palette.background.default}}>
          <RealtyFormContainer values={dealData.realty}/>
        </Item>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.DECLARANT} />
            </Item>
          </Grid>

          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <FilesListContainer />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <XmlList value={dealData?.dealXmlStatementsList} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <Responsible value={dealData.user} />
            </Item>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.REPRESENTATIVE} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.EXT_SIGNER} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <ChildStatmentContainer />
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <DealCommentContainer />
            </Item>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export function MakingChangesParamsContainer({onChange}) {
  const handleChanges = (name, value) => {
    onChange ? onChange({[name]: value}) : void 0;
  }

  return (
    <Grid container>
      <Grid item xs={6}>
        <Grid container>
          <Grid item xs={12}>
            <FormInputDate label="Дата внесения данных в запись реестра"
              name="regDate"
              onChange={(value) => {
                             handleChanges('regDate', value);
              }}
                           value={dealData?.deal?.regDate}/>
          </Grid>
          <Grid item xs={12} sx={{height: 12}}></Grid>
          <Grid item xs={12}>
            <FormInput label="Номер записи реестра"
              name="regNumber"
              fullWidth={400}
                       onChange={waitInputComplete((e) => onChange({regNumber: e.target.value}), 1500)}
                       value={dealData?.deal?.regNumber}/>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container>
          <Grid item xs={12}>
            <Textarea label="Описание изменений" name="changesDescription"
                      multiline={true} rows={3} value={dealData?.deal?.changesDescription}
                      onChange={waitInputComplete((e) => onChange({changesDescription: e.target.value}), 1500)}/>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}